import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  IoMenu, 
  IoClose, 
  IoLogoGithub,
  IoLogoLinkedin,
  IoLogoTwitter,
  IoLogoInstagram
} from 'react-icons/io5';

const Navbar = ({ activeSection, navigateToSection, darkMode, toggleDarkMode }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigationItems = [
    { id: 'about', label: 'About' },
    { id: 'resume', label: 'Resume' },
    { id: 'portfolio', label: 'Portfolio' },
    { id: 'blog', label: 'Blog' },
    { id: 'contact', label: 'Contact' }
  ];

  const socialLinks = [
    { icon: IoLogoGithub, href: 'https://github.com/rayyanshaheer', label: 'GitHub' },
    { icon: IoLogoLinkedin, href: 'https://linkedin.com/in/rayyanshaheer', label: 'LinkedIn' },
    { icon: IoLogoTwitter, href: 'https://twitter.com/rayyanshaheer', label: 'Twitter' },
    { icon: IoLogoInstagram, href: 'https://instagram.com/rayyanshaheer', label: 'Instagram' }
  ];

  const handleMenuItemClick = (sectionId) => {
    navigateToSection(sectionId);
    setIsMenuOpen(false);
  };

  return (
    <>
      {/* Mobile Navbar */}
      <nav className="lg:hidden sticky top-0 bg-card-dark/95 backdrop-blur-md border-b border-jet/30 z-50">
        <div className="flex items-center justify-between p-4">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img
              src="/my-avatar.jpg"
              alt="Rayyan Shaheer"
              className="w-10 h-10 rounded-lg object-cover"
            />
            <div>
              <h1 className="text-lg font-bold text-white-1">Rayyan Shaheer</h1>
              <p className="text-xs text-accent-yellow">Web Developer</p>
            </div>
          </div>

          {/* Menu Button */}
          <div className="flex items-center gap-2">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-lg bg-jet/50 text-white-1 hover:bg-jet transition-colors duration-300"
            >
              {isMenuOpen ? <IoClose size={24} /> : <IoMenu size={24} />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="lg:hidden fixed inset-0 bg-black/50 z-50"
            onClick={() => setIsMenuOpen(false)}
          >
            <motion.div
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ type: 'tween', duration: 0.3 }}
              className="absolute right-0 top-0 h-full w-80 bg-card-dark border-l border-jet/30 p-6"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Menu Header */}
              <div className="flex items-center justify-between mb-8">
                <h2 className="text-xl font-bold text-white-1">Navigation</h2>
                <button
                  onClick={() => setIsMenuOpen(false)}
                  className="p-2 rounded-lg bg-jet/50 text-white-1 hover:bg-jet transition-colors duration-300"
                >
                  <IoClose size={20} />
                </button>
              </div>

              {/* Navigation Items */}
              <nav className="mb-8">
                <ul className="space-y-2">
                  {navigationItems.map((item) => (
                    <li key={item.id}>
                      <button
                        onClick={() => handleMenuItemClick(item.id)}
                        className={`w-full text-left px-4 py-3 rounded-lg font-medium transition-all duration-300 ${
                          activeSection === item.id
                            ? 'bg-accent-yellow text-bg-dark'
                            : 'text-light-gray hover:text-white-1 hover:bg-jet/50'
                        }`}
                      >
                        {item.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>

              {/* Social Links */}
              <div className="border-t border-jet pt-6">
                <h3 className="text-sm font-semibold text-light-gray mb-4 uppercase tracking-wider">
                  Connect
                </h3>
                <div className="flex gap-3 flex-wrap">
                  {socialLinks.map((social, index) => (
                    <motion.a
                      key={index}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      className="w-12 h-12 bg-jet rounded-lg flex items-center justify-center text-light-gray hover:text-accent-yellow hover:bg-accent-yellow/10 transition-all duration-300"
                      aria-label={social.label}
                    >
                      <social.icon size={20} />
                    </motion.a>
                  ))}
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
